import { useMutation } from 'react-query'
import request from '../../request'

export const useCreateBillingPortalSession = () => {
  return useMutation(({ agency_id }: { agency_id: string | number }) =>
    request<{ url: string }>({
      url: `/agencies/${agency_id}/payments/billing-portal?return_url=${window.location.href}`,
      method: 'POST',
    }),
  )
}
